const configure = {
  apiUrl: "https://api.zithas.com/api",
  imgUrl: "https://api.zithas.com/application/public",   // Live
  nodeApi: 'https://napi.zithas.com/api',
  nodeImgApi: 'https://napi.zithas.com',
  exchangeKey: "HBhbjhBY9Zui0q8XUT0O7BcuFgs9l5q5",
  domain: "earth.zithas.com",
  type: 2, // Earth

  // imgUrl: "https://mars.ztpl.net/application/public",
  // apiUrl: "https://mars.ztpl.net/api",                   // Ztpl

  // apiUrl: "https://edemoapi.zithas.com/api",
  // imgUrl: "https://edemoapi.zithas.com/application/public",    // demo Ztpl
  // nodeApi: 'https://endemoapi.zithas.com/api',
  // nodeImgApi: 'https://endemoapi.zithas.com',
  // exchangeKey: "M5CQtQbJko1A2CDN4tjHvF9qFTkgQIoG",
  // domain: "edemo.zithas.com/live",
  //   Edemo Live - domain = edemo.zithas.com/live 
  //  edemo - domain =  edemo.zithas.com 

  // Exchange rate Api Key

  // appUrl: "/RX6T0QNRP6V2Y8YX3FFS/",
  // appUrl: "/finance-module/",
  appUrl: "/",

  // type: 1, // 192 
  //  apiUrl: "http://192.168.0.2/earthbms/admin/api",

  location: [1, 3] //india | US
}

export default configure